import React from "react";
import "./CSS/Occassion.css";
import { Link } from "react-router-dom";
import wedding from "./IMAGES/Traditional Wear.png";
import festival from "./IMAGES/Festival Special.png";
import office from "./IMAGES/Office & Daily Wear.png";
import party from "./IMAGES/Party Wear.png";
import kids from "./IMAGES/Component 24.png";

import mobile1 from "./IMAGES/Mobile Wedding.png";
import mobile2 from "./IMAGES/Mobile Festive.png";
import mobile3 from "./IMAGES/mobile 3rd.png";
import mobile4 from "./IMAGES/Mobile Party.png";
import mobile5 from "./IMAGES/Frame 1000006328.png";

import mobilesvg from "./IMAGES/Frame 1000006324.png";

import mobileBgWedding from "./IMAGES/Pastel 1.png";
import mobileBgFestive from "./IMAGES/Pastel 2.png";
import mobileBgOffice from "./IMAGES/Pastel 3.png";
import mobileBgParty from "./IMAGES/Pastel 4.png";
import mobileBgKids from "./IMAGES/mobile-bg-kids.png";
const mobileCards = [
  {
    image: mobile1,
    bg: mobileBgWedding,
    title: "Wedding Collection",
    desc: "Gracefully handcrafted ensembles made for your most unforgettable celebrations.",
  },
  {
    image: mobile2,
    bg: mobileBgFestive,
    title: "Festive Special",
    desc: "Elegant, comfortable styles designed for everyday confidence.",
  },
  {
    image: mobile3,
    bg: mobileBgOffice,
    title: "Office & Daily Wear",
    desc: "Celebrate traditions in vibrant hues and timeless craftsmanship.",
  },
  {
    image: mobile4,
    bg: mobileBgParty,
    title: "Party Wear",
    desc: "Statement pieces that blend modern charm with ethnic elegance.",
  },
  // {
  //   image: mobile5,
  //   bg: mobileBgKids,
  //   title: "Kids Festive Wear",
  //   desc: "Soft, joyful ethnic wear crafted for your little stars.",
  // },
];
export default function ShopOccasion() {
  return (
    <>
      <div className="occasion-wrapper" id="shop-occasion">
        <section className="occasion">
          <div className="occasion-header">
            <h2>Shop By Occassion</h2>
            <Link to="/shop" className="see-all">
              See all
            </Link>{" "}
          </div>

          <p className="subtitlea">
            Curated styles thoughtfully designed for every special moment of
            your life.
          </p>

          <div className="mobile-wrapper">
            {mobileCards.map((card, index) => (
              <div className="mobile-occasion-card" key={index}>
                <img
                  src={card.image}
                  alt={card.title}
                  className="mobile-main-img"
                />

                <img src={card.bg} alt="mobile bg" className="mobile-bg-img" />

                <div className="mobile-content">
                  <h3>{card.title}</h3>

                  <p>{card.desc}</p>

                  <Link to="/shop" className="explore-btn">
                    Explore Now
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M6.4 18L5 16.6L14.6 7H6V5H18V17H16V8.4L6.4 18Z"
                          fill="#000"
                        />
                      </svg>
                    </span>
                  </Link>
                </div>
              </div>
            ))}
          </div>
          <div className="occasion-container">
            {/* Left Card */}
            <div className="left-card">
              <img src={wedding} alt="wedding" />
            </div>

            {/* Right Card */}
            <div className="right-card">
              <svg
                className="bg-svg"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 401 378"
                preserveAspectRatio="none"
              >
                <path
                  d="M400.157 189.647C399.892 189.162 399.5 188.448 398.99 187.533C397.97 185.704 396.479 183.074 394.598 179.875C390.835 173.476 385.515 164.799 379.278 155.686C373.041 146.571 365.893 137.028 358.479 128.894C351.058 120.751 343.401 114.055 336.15 110.592L335.737 110.394L335.898 109.965C338.242 103.719 339.584 96.983 339.584 89.915C339.584 58.4654 314.191 32.9726 282.868 32.9668C282.281 32.9736 282.281 32.5039 282.254 32.5039C281.198 14.6554 266.488 0.5 248.449 0.5H0V377.5H248.449C266.488 377.5 281.198 363.348 282.254 345.496L282.281 345.026H282.753C314.185 345.029 339.584 319.534 339.584 288.081C339.584 281.017 338.242 274.281 335.898 268.032L335.737 267.603L336.151 267.405C343.405 263.942 351.063 257.387 358.483 249.461C365.898 241.542 373.045 232.286 379.282 223.46C385.518 214.635 390.839 206.246 394.602 200.062C396.482 196.971 397.974 194.432 398.994 192.666C399.504 191.783 399.896 191.094 400.161 190.625C400.274 190.425 400.365 190.267 400.431 190.149C400.365 190.027 400.273 189.859 400.157 189.647Z"
                  fill="#ffeff6"
                  stroke="#da97b5"
                />
              </svg>

              <div className="content">
                <h3>Traditional Wear</h3>
                <p>
                  Gracefully handcrafted ensembles made for your most
                  unforgettable celebrations.
                </p>
                <Link to="/shop" className="explore-btn">
                  Explore Now
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M6.4 18L5 16.6L14.6 7H6V5H18V17H16V8.4L6.4 18Z"
                        fill="#000"
                      />
                    </svg>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </section>
        <section className="occasion">
          <div className="occasion-container">
            <div className="left-card">
              <img src={festival} alt="wedding" />
            </div>
            <div className="right-card">
              <svg
                className="bg-svg"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 401 378"
                preserveAspectRatio="none"
              >
                <path
                  d="M400.157 189.647C399.892 189.162 399.5 188.448 398.99 187.533C397.97 185.704 396.479 183.074 394.598 179.875C390.835 173.476 385.515 164.799 379.278 155.686C373.041 146.571 365.893 137.028 358.479 128.894C351.058 120.751 343.401 114.055 336.15 110.592L335.737 110.394L335.898 109.965C338.242 103.719 339.584 96.983 339.584 89.915C339.584 58.4654 314.191 32.9726 282.868 32.9668C282.281 32.9736 282.281 32.5039 282.254 32.5039C281.198 14.6554 266.488 0.5 248.449 0.5H0V377.5H248.449C266.488 377.5 281.198 363.348 282.254 345.496L282.281 345.026H282.753C314.185 345.029 339.584 319.534 339.584 288.081C339.584 281.017 338.242 274.281 335.898 268.032L335.737 267.603L336.151 267.405C343.405 263.942 351.063 257.387 358.483 249.461C365.898 241.542 373.045 232.286 379.282 223.46C385.518 214.635 390.839 206.246 394.602 200.062C396.482 196.971 397.974 194.432 398.994 192.666C399.504 191.783 399.896 191.094 400.161 190.625C400.274 190.425 400.365 190.267 400.431 190.149C400.365 190.027 400.273 189.859 400.157 189.647Z"
                  fill="#faf8eb"
                  stroke="#d4cb90"
                />
              </svg>

              <div className="content">
                <h3>Festive Special</h3>

                <p>
                  Elegant, comfortable styles designed for everyday confidence.
                </p>
                <Link to="/shop" className="explore-btn">
                  Explore Now
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M6.4 18L5 16.6L14.6 7H6V5H18V17H16V8.4L6.4 18Z"
                        fill="#000"
                      />
                    </svg>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </section>
        <section className="occasion">
          <div className="occasion-container">
            <div className="left-card">
              <img src={office} alt="wedding" />
            </div>
            <div className="right-card">
              <svg
                className="bg-svg"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 401 378"
                preserveAspectRatio="none"
              >
                <path
                  d="M400.157 189.647C399.892 189.162 399.5 188.448 398.99 187.533C397.97 185.704 396.479 183.074 394.598 179.875C390.835 173.476 385.515 164.799 379.278 155.686C373.041 146.571 365.893 137.028 358.479 128.894C351.058 120.751 343.401 114.055 336.15 110.592L335.737 110.394L335.898 109.965C338.242 103.719 339.584 96.983 339.584 89.915C339.584 58.4654 314.191 32.9726 282.868 32.9668C282.281 32.9736 282.281 32.5039 282.254 32.5039C281.198 14.6554 266.488 0.5 248.449 0.5H0V377.5H248.449C266.488 377.5 281.198 363.348 282.254 345.496L282.281 345.026H282.753C314.185 345.029 339.584 319.534 339.584 288.081C339.584 281.017 338.242 274.281 335.898 268.032L335.737 267.603L336.151 267.405C343.405 263.942 351.063 257.387 358.483 249.461C365.898 241.542 373.045 232.286 379.282 223.46C385.518 214.635 390.839 206.246 394.602 200.062C396.482 196.971 397.974 194.432 398.994 192.666C399.504 191.783 399.896 191.094 400.161 190.625C400.274 190.425 400.365 190.267 400.431 190.149C400.365 190.027 400.273 189.859 400.157 189.647Z"
                  fill="#f1ffed"
                  stroke="#a8d39c"
                />
              </svg>

              <div className="content">
                <h3>Office & Daily Wear</h3>
                <p>
                  Celebrate traditions in vibrant hues and timeless
                  craftsmanship.
                </p>
                <Link to="/shop" className="explore-btn">
                  Explore Now
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M6.4 18L5 16.6L14.6 7H6V5H18V17H16V8.4L6.4 18Z"
                        fill="#000"
                      />
                    </svg>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </section>
        <section className="occasion">
          <div className="occasion-container">
            <div className="left-card">
              <img src={party} alt="wedding" />
            </div>
            <div className="right-card">
              <svg
                className="bg-svg"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 401 378"
                preserveAspectRatio="none"
              >
                <path
                  d="M400.157 189.647C399.892 189.162 399.5 188.448 398.99 187.533C397.97 185.704 396.479 183.074 394.598 179.875C390.835 173.476 385.515 164.799 379.278 155.686C373.041 146.571 365.893 137.028 358.479 128.894C351.058 120.751 343.401 114.055 336.15 110.592L335.737 110.394L335.898 109.965C338.242 103.719 339.584 96.983 339.584 89.915C339.584 58.4654 314.191 32.9726 282.868 32.9668C282.281 32.9736 282.281 32.5039 282.254 32.5039C281.198 14.6554 266.488 0.5 248.449 0.5H0V377.5H248.449C266.488 377.5 281.198 363.348 282.254 345.496L282.281 345.026H282.753C314.185 345.029 339.584 319.534 339.584 288.081C339.584 281.017 338.242 274.281 335.898 268.032L335.737 267.603L336.151 267.405C343.405 263.942 351.063 257.387 358.483 249.461C365.898 241.542 373.045 232.286 379.282 223.46C385.518 214.635 390.839 206.246 394.602 200.062C396.482 196.971 397.974 194.432 398.994 192.666C399.504 191.783 399.896 191.094 400.161 190.625C400.274 190.425 400.365 190.267 400.431 190.149C400.365 190.027 400.273 189.859 400.157 189.647Z"
                  fill="#eefcff"
                  stroke="#a2cfd9"
                />
              </svg>

              <div className="content">
                <h3>Party Wear</h3>
                <p>
                  Statement pieces that blend modern charm with ethnic elegance.
                </p>
                <Link to="/shop" className="explore-btn">
                  Explore Now
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M6.4 18L5 16.6L14.6 7H6V5H18V17H16V8.4L6.4 18Z"
                        fill="#000"
                      />
                    </svg>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </section>
        {/* <section className="occasion">
          <div className="occasion-container">
            <div className="left-card">
              <img src={kids} alt="wedding" />
            </div>
            <div className="right-card">
              <svg
                className="bg-svg"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 401 378"
                preserveAspectRatio="none"
              >
                <path
                  d="M400.157 189.647C399.892 189.162 399.5 188.448 398.99 187.533C397.97 185.704 396.479 183.074 394.598 179.875C390.835 173.476 385.515 164.799 379.278 155.686C373.041 146.571 365.893 137.028 358.479 128.894C351.058 120.751 343.401 114.055 336.15 110.592L335.737 110.394L335.898 109.965C338.242 103.719 339.584 96.983 339.584 89.915C339.584 58.4654 314.191 32.9726 282.868 32.9668C282.281 32.9736 282.281 32.5039 282.254 32.5039C281.198 14.6554 266.488 0.5 248.449 0.5H0V377.5H248.449C266.488 377.5 281.198 363.348 282.254 345.496L282.281 345.026H282.753C314.185 345.029 339.584 319.534 339.584 288.081C339.584 281.017 338.242 274.281 335.898 268.032L335.737 267.603L336.151 267.405C343.405 263.942 351.063 257.387 358.483 249.461C365.898 241.542 373.045 232.286 379.282 223.46C385.518 214.635 390.839 206.246 394.602 200.062C396.482 196.971 397.974 194.432 398.994 192.666C399.504 191.783 399.896 191.094 400.161 190.625C400.274 190.425 400.365 190.267 400.431 190.149C400.365 190.027 400.273 189.859 400.157 189.647Z"
                  fill="#50C1C7"
                  stroke="#D28E7D"
                />
              </svg>

              <div className="content">
                <h3>Kids Festive Wear</h3>

                <p>Soft, joyful ethnic wear crafted for your little stars. </p>
                <Link to="/shop" className="explore-btn">
                  Explore Now
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M6.4 18L5 16.6L14.6 7H6V5H18V17H16V8.4L6.4 18Z"
                        fill="#fff"
                      />
                    </svg>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </section> */}
      </div>
    </>
  );
}
